module.exports = __webpack_public_path__ + "16a0459756c8cf6f10d8f60aced47f71.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-preppy.png
// module id = 1352
// module chunks = 0